import React, { useMemo } from 'react';
import useAppStore from '../../store/useAppStore.js';
import ProductListingSection from './ProductListingSection.js';
import ReceiptSidebar from './ReceiptSidebar.js';
import ReceiptItemsList from './ReceiptItemsList.js';

const WalkInSection = ({
    categories,
    filteredProducts,
    addReceiptItem,
    getProductAvailability,
    pendingOptions,
    handleAddSelected,
    onTransferToTable,
    handleSubmitSale,
    handleSave,
    handlePrintBill,
    handlePrintOnly,
    handleClear,
    saleError,
    saleMessage,
    printMode,
    setPrintMode,
    waiters = [],
    onPrintWaiterOrder,
    onAddPendingWaiterOrder,
    onAddToWaiterOrder,
    selectedWaiterId,
    onChangeWaiter,
    waiterOrderOptions,
    selectedWaiterOrderId,
    onChangeWaiterOrder,
    branchReceiptData,
    editingOrder,
    handleUpdateOrder,
    isSubmitting = false,
    isPrintPending = false
}) => {
    const {
        category,
        setCategory,
        receiptItems,
        selectedPending,
        setSelectedPending,
        discount,
        setDiscount,
        receivedCash,
        setReceivedCash,
        updateReceiptQuantity,
        removeReceiptItem
    } = useAppStore((state) => ({
        category: state.category,
        setCategory: state.setCategory,
        receiptItems: state.receiptItems,
        selectedPending: state.selectedPending,
        setSelectedPending: state.setSelectedPending,
        discount: state.discount,
        setDiscount: state.setDiscount,
        receivedCash: state.receivedCash,
        setReceivedCash: state.setReceivedCash,
        updateReceiptQuantity: state.updateReceiptQuantity,
        removeReceiptItem: state.removeReceiptItem
    }));

    const subtotal = useMemo(
        () => receiptItems.reduce((sum, item) => sum + item.price * item.quantity, 0),
        [receiptItems]
    );

    const discountValue = Math.min(Number(discount) || 0, subtotal);
    const grandTotal = subtotal - discountValue;
    const balance = Number(receivedCash || 0) - grandTotal;

    return (
        <div className="space-y-2">
            <div className="grid grid-cols-1 xl:grid-cols-[1.55fr_1fr] gap-2">
                <ProductListingSection
                    categories={categories}
                    category={category}
                    setCategory={setCategory}
                    filteredProducts={filteredProducts}
                    addReceiptItem={addReceiptItem}
                    getProductAvailability={getProductAvailability}
                    receiptItems={receiptItems}
                />
                <div className="p-4 bg-white rounded-3xl shadow-sm" >
                    <ReceiptItemsList
                        receiptItems={receiptItems}
                        onQuantityChange={updateReceiptQuantity}
                        onRemove={removeReceiptItem}
                    />
                </div>

            </div>
            <ReceiptSidebar
                receiptItems={receiptItems}
                selectedPending={selectedPending}
                setSelectedPending={setSelectedPending}
                pendingOptions={pendingOptions}
                handleAddSelected={handleAddSelected}
                onTransferToTable={onTransferToTable}
                discount={discount}
                setDiscount={setDiscount}
                receivedCash={receivedCash}
                setReceivedCash={setReceivedCash}
                balance={balance}
                saleError={saleError}
                saleMessage={saleMessage}
                handleSave={handleSave}
                handlePrintBill={handlePrintBill}
                handlePrintOnly={handlePrintOnly}
                handleClear={handleClear}
                printMode={printMode}
                setPrintMode={setPrintMode}
                waiters={waiters}
                selectedWaiterId={selectedWaiterId}
                onChangeWaiter={onChangeWaiter}
                waiterOrderOptions={waiterOrderOptions}
                selectedWaiterOrderId={selectedWaiterOrderId}
                onChangeWaiterOrder={onChangeWaiterOrder}
                onPrintWaiterOrder={onPrintWaiterOrder}
                onAddPendingWaiterOrder={onAddPendingWaiterOrder}
                onAddToWaiterOrder={onAddToWaiterOrder}
                branchReceiptData={branchReceiptData}
                showPrintOnly={true}
                editingOrder={editingOrder}
                handleUpdateOrder={handleUpdateOrder}
                isSubmitting={isSubmitting}
                isPrintPending={isPrintPending}
            />
        </div>
    );
};

export default WalkInSection;
